import { render, staticRenderFns } from "./Certify.vue?vue&type=template&id=45aa6e60&scoped=true&"
import script from "./Certify.vue?vue&type=script&lang=js&"
export * from "./Certify.vue?vue&type=script&lang=js&"
import style0 from "./Certify.vue?vue&type=style&index=0&id=45aa6e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa6e60",
  null
  
)

export default component.exports